import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FlowchartService } from 'src/app/Service/Flowchart/Flowchart.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-FlowchartMain',
  templateUrl: './FlowchartMain.component.html',
  styleUrls: ['./FlowchartMain.component.css']
})
export class FlowchartMainComponent implements OnInit {


  
  Token:String=""
  BaseUrl=environment.BaseUrl
  BaseUrl1=environment.BaseUrl
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;
  DataList_Flowchart:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  constructor(
    private Flowchart_Service:FlowchartService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.BaseUrl =  environment.BaseUrl+"flowchart/Flowchartt?token="+this.Token
    this.BaseUrl1 =  environment.BaseUrl+"flowchart/Workflow?token="+this.Token+"&id="
    this.Nav_Service.CheckValidPage(this.Token,2192).subscribe(
      data=>{
        this.ReadData_Flowchart()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

    
  }

  ReadData_Flowchart(){
    this.Procssing=true
    this.Flowchart_Service.GetFlowchart(this.Token).subscribe(
      data=>{
        this.DataList_Flowchart=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.Flowchart_Service.DeleteFlowchart(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully.")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully.")
        this.ReadData_Flowchart()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }
}
